module.exports = __webpack_public_path__ + "static/media/iron_medal.e3014d36.png";